module.exports = __webpack_public_path__ + "img/数据资产(旧)select.52df2964.svg";